import { render, staticRenderFns } from "./EstablishmentCard.vue?vue&type=template&id=548907a6&scoped=true&lang=html&"
import script from "./EstablishmentCard.vue?vue&type=script&lang=js&"
export * from "./EstablishmentCard.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentCard.vue?vue&type=style&index=0&id=548907a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548907a6",
  null
  
)

component.options.__file = "EstablishmentCard.vue"
export default component.exports